export { default } from "./BaseSpinner.vue";
